<template>
  <el-select
    v-model="selectedOption"
    :placeholder="placeholder"
    :multiple="multiple"
    :filterable="filterable"
    @change="onChange"
    clearable
    class="w-100"
    v-loading="loading"
  >
    <el-option v-for="option in options" :key="option.value" :label="option.label" :value="option.value" :disabled="option.items === 0">
      <span class="m-r-small">{{ option.label }}</span>
    </el-option>
  </el-select>
</template>

<script>
import { find } from 'lodash';

export default {
  name: 'Select',

  props: {
    filterable: {
      type: Boolean,
      required: false,
      default: false
    },

    loading: {
      type: Boolean,
      required: false,
      default: false
    },

    multiple: {
      type: Boolean,
      required: false,
      default: false
    },

    options: {
      type: Array,
      required: true
    },

    placeholder: {
      type: String,
      required: false,
      default: ''
    },

    selected: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      selectedOption: null
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.setInitalValue();
    },

    onChange(value) {
      if (!this.options.length) {
        return false;
      }

      const item = find(this.options, { id: value }) || null;

      this.$emit('on-change', item);
    },

    setInitalValue() {
      if (this.selected.hasOwnProperty('id')) {
        this.selectedOption = this.selected.id;
      } else {
        this.selectedOption = null;
      }
    }
  },

  watch: {
    selected() {
      this.setInitalValue();
    }
  }
};
</script>
